export const revenueCatKey = {
  development: "rcb_sb_tVlqhuWKLGRuBrfeQGChTxgOQ",
  staging: "rcb_sb_tVlqhuWKLGRuBrfeQGChTxgOQ",
  production: "rcb_SydwmMIsupppEzFkwrKNlVPABjsb",
};
